import { UserType } from "@inrev/common";
import { useAuthenticatedUser } from "@portal/providers/AuthenticatedUserProvider";
import { useQuery } from "@tanstack/react-query";
import { ADMIN_BASE_URL, AGENT_BASE_URL } from "../../constants";
import { useRequest } from "../../utils/request";
import { SuretyBondPreview } from "../bond/agent/types";
import { bondPreviewsQueryKey } from "../bond/bond.keys";

export const useFetchBondPreviews = () => {
	const { user } = useAuthenticatedUser();
	const { get } = useRequest();

	const baseUrl = user.type === UserType.admin ? ADMIN_BASE_URL : AGENT_BASE_URL;

	const { data, error, isLoading, refetch } = useQuery({
		queryKey: bondPreviewsQueryKey(),
		queryFn: async () => await get<SuretyBondPreview[]>(baseUrl + "/surety/bonds/previews"),
	});

	return {
		bondPreviews: data,
		bondPreviewsError: error,
		bondPreviewsIsLoading: isLoading,
		refetchBondPreviews: refetch,
	};
};
